import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from 'src/app/_services/alert.service';
import { ModalComponent } from 'src/app/common/modal/modal.component';
import { ModalConfig } from 'src/app/common/modal/modal.config';
import { ProductCategoryService } from '../product-category-service';
import { ProductService } from '../../product-management/product-service';
import Swal from 'sweetalert2';
import { Location } from '@angular/common';
import { MenusService } from 'src/app/_services/menu.service';

@Component({
  selector: 'app-product-category-edit',
  templateUrl: './product-category-edit.component.html',
  styleUrls: ['./product-category-edit.component.scss']
})
export class ProductCategoryEditComponent implements OnInit {

  selectedFile: SafeUrl = 'assets/images/product.png';
  submitted: boolean = false;
  editCategoryForm !:FormGroup
  editData : any;
  id : any;
  subCategoryMappedList : any;
  dbStatus : string;
  selectedStatus : string;
  public permissions : any; 
  constructor(private router : Router,private menuService : MenusService, private location : Location,private formBuilder : FormBuilder,private alertService : AlertService,private categoryService : ProductCategoryService,private route : ActivatedRoute,private productService : ProductService,private sanitizer: DomSanitizer) { }

  @ViewChild('editProductCategoryModalOpen') private editProductCategoryModal: ModalComponent;
  modalProductCategory: ModalConfig;

  ngOnInit(): void {

    const path = "/productCategory/productCategoryList";
    this.permissions = this.menuService.getPermissions(path);
    console.log(this.permissions);
    
    this.editCategoryForm = this.formBuilder.group({
      categoryImage : ['',Validators.required],
      categoryName : ['',Validators.required],
      categoryDesc : ['',Validators.required],
      status : [null,Validators.required]

    })

    this.id = this.route.snapshot.queryParamMap.get("mid");
    this.categoryService.getCategoryById(this.id).subscribe((response:any)=>{
      console.log(response);
      console.log(response.response);
      this.setCategoryProfileByApi(response.response.data.icon);
      this.editCategoryForm.controls.categoryName.setValue(response.response.data.name);
      this.editCategoryForm.controls.categoryDesc.setValue(response.response.data.description);
      this.editCategoryForm.controls.status.setValue(response.response.data.status);
      this.dbStatus = response.response.data.status;
      this.selectedStatus = response.response.data.status;
      this.subCategoryMappedList = response.response.data.subCategory;
    })


    this.modalProductCategory = {
      modalTitle: "Product Category",
      modalSize: 'lg',
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }
  }

  cancelButton(){
    this.router.navigateByUrl('/productCategory/productCategoryList')
  }


  setCategoryProfileByApi(profile: any) {
    console.log("Choose File "+profile);
    let url = "category/"+profile;
    this.productService.getProfileImage(url).subscribe((response:any)=>{
      console.log(response);
      if(response.type == 'application/json'){
        this.editCategoryForm.get('categoryImage')?.setValue(profile);
        this.selectedFile = 'assets/images/product.png';
      }else{
        let file = new File([response], url, { type: response.type });
        this.editCategoryForm.get('categoryImage')?.setValue(file);
        let imageUrl = URL.createObjectURL(response);
        this.selectedFile = this.sanitizer.bypassSecurityTrustUrl(imageUrl);
      }
    })
  }

  setCategoryProfile(profile : any){
    console.log("Choose File Clicked");
    var file = profile.target.files[0];
    console.log(file);
    if(file.size > 50000){
      console.log("Greater than 50 KB");
      Swal.fire('Icon size cannot be greater than 50 KB','','error');
      return;
    }
    profile.target.value = '';
    console.log("edit")
    this.editCategoryForm.get('categoryImage')?.setValue(file);
    var reader = new FileReader();
    reader.onloadend = this.handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);

  }

  handleReaderLoaded(e: any) {
    let reader = e.target;
    this.selectedFile = reader.result;
    console.log("Image Data"+reader.result)
  }

  removeFile() {
    this.selectedFile = 'assets/images/product.png';
    this.editCategoryForm.get('categoryImage')?.reset();
  }

  setProfileById(id:any){
    //API call for base64
    console.log("Choose File Clicked" +id);
    this.editCategoryForm.controls.categoryImage.setValue(id);
  }

  closeModalBlocked($event: any) {
    if (!$event.showModal) {
      this.editProductCategoryModal.close();
      this.editCategoryForm.controls.status.setValue(null);
    }
  }

  editCategory(data:any){
    this.submitted = true;
    if(this.editCategoryForm.valid){
      console.log("Valid");
      let requestForm = {
        "id":this.id,
        "name": data.categoryName,
        "description": data.categoryDesc,
        // "status": data.status
      };
      var requestData = new FormData();
      requestData.append("icon",this.editCategoryForm.value.categoryImage);
      requestData.append("request",JSON.stringify(requestForm));
      console.log(requestData);
      console.log("Update Active");
      this.categoryService.updateCategory(requestData).subscribe((response:any)=>{
        console.log(response);
        if(response.response.status == 200){
          Swal.fire(response.response.message, '', 'success').then((result)=>{
            if (result.isConfirmed) {
              this.router.navigate(['/productCategory/productCategoryList']);
            } 
          });
        }else{
          Swal.fire(response.response.message, '', 'error');
        }
      })
      

    }else{
      console.log("Not Valid");
    }
    }

    confirmModal(){
      this.editProductCategoryModal.close();
      this.editCategoryForm.controls.status.setValue("INACTIVE");
    }

    categoryStatusChange(selectedStatus : any){
      this.selectedStatus = selectedStatus;
      if(this.selectedStatus == "INACTIVE"){
        this.editProductCategoryModal.open();
      }
    }

    // Method to validate category name input (alphanumeric, underscore, and spaces allowed)
    onCategoryNameKeyPress(event: any): boolean {
      const charCode = event.which || event.keyCode;
      const char = String.fromCharCode(charCode);
      
      // Allow: backspace, delete, tab, escape, enter
      if ([8, 9, 27, 13, 46].indexOf(charCode) !== -1) {
        return true;
      }
      
      // Allow: alphanumeric characters (a-z, A-Z, 0-9), underscore (_), and space
      const pattern = /^[a-zA-Z0-9_ ]$/;
      if (!pattern.test(char)) {
        event.preventDefault();
        return false;
      }
      
      return true;
    }

    // Method to validate category description input (alphanumeric, underscore, and spaces allowed)
    onCategoryDescKeyPress(event: any): boolean {
      const charCode = event.which || event.keyCode;
      const char = String.fromCharCode(charCode);
      
      // Allow: backspace, delete, tab, escape, enter
      if ([8, 9, 27, 13, 46].indexOf(charCode) !== -1) {
        return true;
      }
      
      // Allow: alphanumeric characters (a-z, A-Z, 0-9), underscore (_), and space
      const pattern = /^[a-zA-Z0-9_ ]$/;
      if (!pattern.test(char)) {
        event.preventDefault();
        return false;
      }
      
      return true;
    }

    statusUpdate(){
      if(this.selectedStatus == undefined){
        Swal.fire('Please select Status','','error');
        return;
      }
      if(this.dbStatus == this.selectedStatus){
        Swal.fire('Status is already '+this.selectedStatus,'','error');
      }else{
        this.productService.categoryStatusChange(this.id,this.selectedStatus).subscribe((response:any)=>{
          console.log(response);
          if(response.response.status == 200){
            Swal.fire('Status Updated Successfully','','success');
          }else{
            Swal.fire(response.response.message,'','error');
          }
        })
      }
    }
}
